<template>
  <div class="progress-container mb-5">
    <div class="progress-label text-center mb-2">
      مرحله {{ step }} از {{ totalSteps }}
    </div>
    <div class="progress rounded shadow-sm progress-bar-height">
      <div
          class="progress-bar rounded"
          :style="{ width: progressPercentage + '%' }"
          role="progressbar"
          :aria-valuenow="progressPercentage"
          aria-valuemin="0"
          aria-valuemax="100"
      >
        <span class="progress-text">{{ progressText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      required: true
    },
    totalSteps: {
      type: Number,
      required: true
    }
  },
  computed: {
    progressPercentage() {
      return (this.step / this.totalSteps) * 100;
    },
    progressText() {
      return `${this.progressPercentage.toFixed(0)}%`;
    }
  }
};
</script>

<style scoped>
.progress-container {
  width: 100%;
  //max-width: 34vw;
  max-width: 71vw;
  margin: 0 auto;
}

.progress-label {
  font-size: 1vw;
  color: #2c3e50;
  font-weight: bold;
}

.progress {
  background-color: #e9ecef;
  height: 1vw;
}

.progress-bar {
  background: linear-gradient(90deg, #1f2cfc, #3742F9);
  color: white;
  font-weight: bold;
  font-size: 0.7vw;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: width 0.4s ease;

}

.progress-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
